module.exports = __webpack_public_path__ + "img/join-bhc.15c53caf.jpg";